import estilos from '../DetalleDeCompraComponent.module.css'
import React, { useState, Fragment } from 'react'
import moment from 'moment'
import BotonVerArchivoComponent from './BotonVerArchivoComponent'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { agregarInformacionCompra, obtenerContadorCompras } from '../../../../../redux/DuckPanelHologramas/ModuloComprasDuck'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const FinanzasComponent = (props) => {
    const dataUser = useSelector(store => store.Usuario.user)
    let detalleCompra = props.detalleCompra

    var fechaHoy = moment().format('YYYY-MM-DD');
    const dispatch = useDispatch()

    const numeropedido = useSelector(store => store.ModuloCompras.contadorPedido)
    const [estatus, setEstatus] = React.useState(detalleCompra?.solicitudescomprashologramas.length > 0 ? detalleCompra?.solicitudescomprashologramas?.[0]?.estatus : 'Por Confirmar')
    const [observaciones, setObservaciones] = React.useState(detalleCompra?.solicitudescomprashologramas.length > 0 ? detalleCompra?.solicitudescomprashologramas?.[0]?.observaciones : '')

    const [agregado, setAgregado] = React.useState(false)

    const [openModal, setOpenModal] = React.useState(false)
    const [titleModal, setTitleModal] = React.useState('')
    const [bodyModal, setBodyModal] = React.useState('')
    const [botonModal, setBotonModal] = React.useState('')
    const [deshabilitarBoton, setDeshabilitarBoton] = React.useState(false)
    const cancelarModal = () => setOpenModal(false)

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        p: 4,
    };

    const guardarCambios = async () => {
        if (estatus == 'Confirmado') {
            setTitleModal('Confirmación de compra.')
            setBodyModal('¿Estás seguro que deseas realizar la compra? No se podrán realizar cambios después.')           
            setBotonModal('Continuar')
            setOpenModal(true)
        } else {
            setTitleModal('¡Tenemos un problema!')           
            setBodyModal('Es necesario cambiar el estatus.')
            setBotonModal('Aceptar')
            setOpenModal(true)
        }
    }

    const closeModal = async () => {
        if(botonModal == "Continuar"){
            setOpenModal(false)
            setDeshabilitarBoton(true)

            let fechaSolicitud = new Date(fechaHoy).toISOString()
            let numPedido = ''
            const data = {
                estatus: estatus, observaciones: observaciones, fechaatendida: fechaSolicitud,
                idfc40_solicitudadquisicionholo: detalleCompra.idfc40_solicitudadquisicionholo,
                idloginfc40_solicitudadquisicionholo: detalleCompra?.login?.cliente?.[0]?.idlogin,
                prefijo: '', folioinicial: '', foliofinal: '', numeropedido: Number(Number(numeropedido) + Number(1))?.toString()
            }
            await dispatch(agregarInformacionCompra(data))
            setAgregado(true)
            
            props.history.push('/PanelComprasComponent')
        }else
        setOpenModal(false)
    }

    const cancelarCambios = () => {
        props.history.push('/PanelComprasComponent')
    }

    React.useEffect(async () => {
        await dispatch(obtenerContadorCompras())
    }, [])

    return (
        <div className={`${estilos.contenedor} row`}>
            <div className="col-md-4 mt-3 text-start"><label><b>Número de pedido: </b> <br/>
                {(detalleCompra?.solicitudescomprashologramas?.[0]?.numeropedido != null || detalleCompra?.solicitudescomprashologramas?.[0]?.numeropedido != undefined) ?
                  detalleCompra?.solicitudescomprashologramas?.[0]?.numeropedido :
                  Number(Number(numeropedido) + Number(1))} </label>
            </div>
            
            <div className='col-md-6'></div>

            <div className="col-md-2 mt-3 text-start"><label><b>Fecha actual: </b> <br/> {fechaHoy} </label></div>

            <div className="col-md-6 mt-4 text-start"><label><b>Nombre o Razón social: </b> <br/> {detalleCompra.nombrerazonsocial} </label></div>

            <div className='col-md-12'> 
                <br/>
                <h5> HOLOGRAMAS SOLICITADOS</h5>
            </div>

            <table className={`table table-bordered ${estilos.tabla}`}>
                <thead>
                    <tr>
                        <th scope="col" className= "w-25">Mezcal</th>
                        <th scope="col" className= "w-25">Bebidas con mezcal</th>
                        <th scope="col" className= "w-25">Referencia de pago</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>               
                        <td> {detalleCompra?.cantidadmezcal != "" ? detalleCompra.cantidadmezcal : 0} </td>
                        <td> {detalleCompra?.cantidadbebidasmezcal != "" ? detalleCompra.cantidadbebidasmezcal : 0} </td>
                        <td> <BotonVerArchivoComponent tabla={'fc_40archivos'} nombreId={'idfc40_solicitudadquisicionholo'} idSolicitud={detalleCompra.idfc40_solicitudadquisicionholo} nameid={'DGPT'} /> </td>
                    </tr>
                </tbody>
            </table>

            <div className='col-md-6 mt-4'>
                <div className="form-floating mb-3">
                    <select className={`form-select `}
                        value={estatus} onChange={e => setEstatus(e.target.value)} disabled={dataUser?.[0]?.idtipousuario != 10 || detalleCompra?.solicitudescomprashologramas.length > 0}>
                        <option value="">Seleccione un estatus</option>
                        <option value={`Por Confirmar`} >{`Por Confirmar`}</option>
                        <option value={`Confirmado`} >{`Confirmado`}</option>
                    </select>
                    <label htmlFor='floatingInput'>Estatus</label>
                </div>
            </div>

            <div className='col-md-6 mt-4'>
                <div className="form-floating mb-3" color='black'>
                    <textarea className="form-control" rows="4" style={{ height: "7%" }} value={observaciones} onChange={e => setObservaciones(e.target.value)}
                        disabled={dataUser?.[0]?.idtipousuario != 10 || detalleCompra?.solicitudescomprashologramas.length > 0} />
                    <label htmlFor="floatingInput">Observaciones</label>
                </div>
            </div>
            
            {dataUser?.[0]?.idtipousuario == 10 &&
                <Fragment>
                    <div className='col-md-6 mt-5'>
                        <button onClick={() => guardarCambios()} className='btn btn-outline-success'
                            disabled={detalleCompra.solicitudescomprashologramas.length != 0 || agregado}>Guardar Cambios</button>
                    </div>
                    <div className='col-md-6 mt-5'>
                        <button onClick={() => cancelarCambios()} className='btn btn-outline-danger'>Cancelar cambios</button>
                    </div>
                </Fragment>
            }
            <Modal
                open={openModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        <center><strong>{titleModal}</strong></center>
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <center>{bodyModal}</center>
                    </Typography>
                    <Typography sx={{ mt: 5 }}>
                        <button className={`btn ${estilos.botonModal}`} onClick={closeModal}> {botonModal} </button>
                    </Typography>
                    {
                        botonModal == "Continuar" &&
                        <Typography sx={{ mt: 2 }}>
                            <button className={`btn ${estilos.botonCancelarModal}`} onClick={cancelarModal}> Cancelar </button>
                        </Typography>

                    }
                </Box>
            </Modal>
        </div>
    );
};

export default withRouter(FinanzasComponent)
